import { useState } from 'react';
import { FileText, Loader2, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { ResumeBuilderSsoButton } from './ResumeBuilderSsoButton';
import { resumeMarketingService } from '../services/resumeMarketing.service';

export function ResumeBuilderResumeItem({
  resume,
  returnPath,
  nested = false,
  isTl = false,
  buttonClassName,
  onDeleted,
}) {
  const [deleting, setDeleting] = useState(false);

  const displayTitle =
    resume.candidateName?.trim() ||
    resume.title?.trim() ||
    'Untitled resume';

  const handleDelete = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (deleting) return;

    const confirmed = window.confirm(
      `Delete "${displayTitle}"? This cannot be undone.`
    );
    if (!confirmed) return;

    setDeleting(true);
    try {
      const result = await resumeMarketingService.deleteResumeBuilder(resume.id);
      toast.success(result?.message || 'Resume deleted.');
      onDeleted?.(resume.id);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Failed to delete resume.'
      );
    } finally {
      setDeleting(false);
    }
  };

  const rowClass = isTl
    ? 'flex items-center gap-1 pr-2'
    : 'flex items-center gap-1';

  const deleteClass = isTl
    ? 'flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-content-muted transition-colors hover:bg-rose-50 hover:text-rose-600 disabled:opacity-50'
    : 'flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-content-muted transition-colors hover:bg-rose-50 hover:text-rose-600 disabled:opacity-50';

  return (
    <div className={rowClass}>
      <div className="min-w-0 flex-1">
        <ResumeBuilderSsoButton
          returnPath={returnPath}
          targetPath={`/dashboard/resumes/${resume.id}/edit`}
          label={resume.label || displayTitle}
          icon={FileText}
          nested={nested}
          className={`${buttonClassName} w-full`}
        />
      </div>
      <button
        type="button"
        onClick={(event) => void handleDelete(event)}
        disabled={deleting}
        className={deleteClass}
        aria-label={`Delete ${displayTitle}`}
        title="Delete resume"
      >
        {deleting ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Trash2 className="h-4 w-4" />
        )}
      </button>
    </div>
  );
}
